import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  setCredentials,
  clearCredentials,
} from "../features/counter/Authslice.js";
import configuration from "../config";
import axios from "axios";
import LandingPage from "../pages/LandingPage";

const AuthRedirect = () => {
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();
  const { API_BASE_URL } = configuration;
  const { isAuthenticated, user } = useSelector((state) => state.auth);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        if (isAuthenticated && user) {
          setIsLoading(false);
          return;
        }

        const existingToken = sessionStorage.getItem("accessToken");

        if (existingToken) {
          axios.defaults.headers.common[
            "Authorization"
          ] = `Bearer ${existingToken}`;

          try {
            const verifyResponse = await axios.get(
              `${API_BASE_URL}/api/v1/verify-token`,
              {
                withCredentials: true,
              }
            );

            if (verifyResponse.data.success && verifyResponse.data.user) {
              dispatch(
                setCredentials({
                  token: existingToken,
                  user: verifyResponse.data.user,
                  isAuthenticated: true,
                })
              );
              setIsLoading(false);
              return;
            }
          } catch (verifyError) {
           
          }
        }

        const response = await axios.get(`${API_BASE_URL}/api/v1/refresh`, {
          withCredentials: true,
        });

        if (response.data.success && response.data.token) {
          sessionStorage.setItem("accessToken", response.data.token);
          axios.defaults.headers.common[
            "Authorization"
          ] = `Bearer ${response.data.token}`;

          dispatch(
            setCredentials({
              token: response.data.token,
              user: response.data.user,
              isAuthenticated: true,
            })
          );
        } else {
          throw new Error("No token received");
        }
      } catch (error) {
        console.error("Auth check failed:", error);

        sessionStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        delete axios.defaults.headers.common["Authorization"];
        dispatch(clearCredentials());
      } finally {
        setIsLoading(false);
      }
    };

    checkAuth();
  }, [dispatch, API_BASE_URL, isAuthenticated, user]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (isAuthenticated && user) {
    return <Navigate to="/KycManagement" replace />;
  }

  return <LandingPage />;
};

export default AuthRedirect;
